import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailUnderEyeArea({data, img}) {
    return (
        <MeasurementResult type="눈밑지방" description='얼굴의 "눈밑지방"은 눈 아래에 위치한 지방을 가리킵니다. 눈밑에는 눈두덩이 또는 눈망울을 지지하고 보호하는 역할을 하는 눈밑 지방이 존재합니다.' 
        score={data.score}>
            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        {
                        img.image_cross_polar_front &&
                        <img src={img.image_cross_polar_front} />
                        }

                        <div className="caption">화이트 라이트</div>
                    </div>
                    {/* <div className="img-cont detail">
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                    </div> */}
                </div>
                <DegreeSection 
                    type="눈밑지방"
                    badge={data.analysisBadge}
                    items={[
                    {
                        value: "없음",
                        label: "0"
                    },
                    {
                        value: "경도",
                        label: "1"
                    },
                    {
                        value: "경도",
                        label: "2"
                    },
                    {
                        value: "중간 정도",
                        label: "3"
                    },
                    {
                        value: "중간 정도",
                        label: "4"
                    },
                    {
                        value: "중증 정도",
                        label: "5"
                    },
                    {
                        value: "중증 정도",
                        label: "6"
                    },
                ]}
                text={data.degreeText}
                levelFloat={data.levelFloat}
                line={2}
                />
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    text={data.aiResult}
                />
            </div>
        </MeasurementResult>
    )
}